import React, { useContext } from 'react';
import { useBookingContext } from '../Context';
import { useCommonBookerProps } from '../hooks/useCommonBookerProps';
import { BookerStateContext } from '../hooks/useRuntimeCalBookingState';
import { LazyBookerWrapper } from '../LazyBooker';
import { LazyNativeBookerWrapper } from '../LazyNativeBooker';
import { NativeBookingWrapper } from '../nativeBookerStyles';
import { CalBookingWrapper } from '../styles';
import RescheduleModal from './RescheduleModal';

const RescheduleModalWrapper = () => {
    const bookerContext = useBookingContext();
    const [bookingState, bookingActions] = useContext(BookerStateContext);

    const { clientId, isBookingDryRun, isNativeBookerEnabled } = bookerContext;
    const { rescheduleUid, apiUrl, language, siteLocale } = bookingState;

    const commonBookerProps = useCommonBookerProps({ calBookerStep: null });
    const showRescheduleModal = !isBookingDryRun && rescheduleUid;

    if (!showRescheduleModal) {
        return null;
    }

    // Mount the native atom's provider + wrapper when the flag is on, the cal
    // atom's otherwise. `RescheduleModal` branches the Booker itself to match.
    const nativeEnabled = isNativeBookerEnabled;
    const BookingWrapper = nativeEnabled
        ? NativeBookingWrapper
        : CalBookingWrapper;
    const ProviderWrapper = nativeEnabled
        ? LazyNativeBookerWrapper
        : LazyBookerWrapper;

    return (
        <BookingWrapper
            data-auto='ssr-cal-booking-widget'
            className='booking-wrapper'
        >
            <ProviderWrapper
                clientId={clientId}
                apiUrl={apiUrl}
                language={nativeEnabled ? siteLocale : language}
            >
                <RescheduleModal
                    bookerProps={{
                        bookingUid: rescheduleUid ?? '',
                        ...commonBookerProps,
                        customClassNames:
                            commonBookerProps.rescheduleClassNames,
                    }}
                    isNativeBookerEnabled={nativeEnabled}
                    onClose={() => bookingActions.setRescheduleUid(null)}
                />
            </ProviderWrapper>
        </BookingWrapper>
    );
};

export default RescheduleModalWrapper;
